import Head from "next/head";
import Footer from "../common/Footer";
import Nav from "../common/nav";

export default function About() {
  return (
    <>
      <Head>
        <title>About | Gwak</title>
        <meta name="description" content="What Gwak is about." />
      </Head>
      <Nav/>
      <section>
        <img
          className="absolute top-0 left-0 mt-24 hidden lg:block"
          src="/page-assets/icons/dots/blue-dot-left-bars.svg"
          alt=""
        />
        <img
          className="absolute top-0 right-0 mt-40 hidden lg:block"
          src="/page-assets/icons/dots/yellow-dot-right-shield.svg"
          alt=""
        />
        <div className="container mx-auto px-4">
          <div className="mx-auto max-w-2xl">
            <h2 className="font-heading mb-10 text-4xl font-semibold">About</h2>
            <p className="mb-6 text-xl text-gray-500">
              Gwak is an application born out of frustration with the status quo
              when it comes to discovering and enjoying good food.
            </p>
            <p className="mb-6 text-xl text-gray-500">
              How is it that we are more connected today than ever before and
              yet the process for finding places to eat is such a pain?
            </p>
            <p className="mb-6 text-xl text-gray-500">
              Gwak does not rely on complicated AI or machine learning. Instead,
              it keeps things simple and leans on our existing network of
              friends to find and share recommendations.
            </p>
            <p className="mb-6 text-xl text-gray-500">
              Gwak is free, does not contain ads, and is available on both
              Android and iOS for maximum reach.
            </p>
          </div>
        </div>
      </section>
      <Footer/>
    </>
  );
}
